// In-memory session buffer: rrweb events + a flattened, LLM-friendly timeline + page context.
// Buffers are capped (with per-channel drop counters shipped in the payload) and byte-accounted
// so the controller can auto-send before the payload gets pathological.

const CHANNEL_CAPS = { click: 5000, network: 2000, console: 500, route: 1000 };

export function createStore() {
  const startedAt = Date.now();
  const t0 = performance.now();
  let bytes = 0;
  const counts = { click: 0, network: 0, console: 0, route: 0 };

  return {
    startedAt,
    rrwebEvents: [],
    timeline: [], // flat list of { type, tMs, ... }
    dropped: { click: 0, network: 0, console: 0, route: 0, rrweb: 0 },
    context: captureContext(startedAt),

    pushRrweb(ev) {
      this.rrwebEvents.push(ev);
      // Approximate accounting; full snapshots are large but rare, incrementals are tiny.
      try { bytes += JSON.stringify(ev).length; } catch (_) { bytes += 1024; }
    },

    push(ev) {
      const cap = CHANNEL_CAPS[ev.type];
      if (cap && counts[ev.type] >= cap) {
        this.dropped[ev.type]++;
        return;
      }
      counts[ev.type]++;
      ev.tMs = Math.round(performance.now() - t0);
      this.timeline.push(ev);
      bytes += 200; // rough per-event estimate; exactness doesn't matter here
    },

    approxBytes() {
      return bytes;
    },
  };
}

function captureContext(startedAt) {
  return {
    url: location.href,
    referrer: document.referrer || null,
    userAgent: navigator.userAgent,
    viewport: { w: window.innerWidth, h: window.innerHeight },
    devicePixelRatio: window.devicePixelRatio || 1,
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    startedAt: new Date(startedAt).toISOString(),
  };
}
